const contentBlockSliderFunctions = () => {
    $(document).on('click', '.js-change-cs-block-slide', function(e) {
        e.preventDefault();

        const slideIndex = $(this).data('slide-index');

        $('.cs-block__slides-nav-item').removeClass('active');
        $(this).addClass('active');
        $('.js-cs-block-slider').slick('slickGoTo', slideIndex, false);
    });
};
